import {useQuery} from "@tanstack/react-query";
import {queryKeys} from "../react-query/constant";
import getPatientInfo from "../api/patientInfo";

export const usePatientInfo = (patientId) => {

    return useQuery([queryKeys.patientInfo,patientId],
        () => getPatientInfo(patientId))

}
